import React, { useEffect, useState } from "react";

const BASE_URL = "https://mis.empowerplus.in";

export default function CreateUserPage() {

    const token = localStorage.getItem("token");

    const [roles, setRoles] = useState([]);

    const [fullName, setFullName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [role, setRole] = useState("");

    const [msg, setMsg] = useState("");

    /* ================= LOAD ROLES ================= */

    const fetchRoles = async () => {

        try {

            const res = await fetch(`${BASE_URL}/api/roles`, {
                headers: { Authorization: `Bearer ${token}` }
            });

            const data = await res.json();

            setRoles(Array.isArray(data) ? data : []);

        } catch {
            console.error("Failed to load roles");
        }

    };

    useEffect(() => {
        fetchRoles();
    }, []);



    /* ================= CREATE USER ================= */

    const handleSubmit = async (e) => {

        e.preventDefault();

        try {

            const res = await fetch(`${BASE_URL}/api/auth/register`, {

                method: "POST",

                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                },

                body: JSON.stringify({
                    fullName,
                    email,
                    password,
                    role
                })

            });

            if (res.ok) {

                setMsg("User created successfully");

                setFullName("");
                setEmail("");
                setPassword("");
                setRole("");

            } else {

                const err = await res.text();
                setMsg(err || "Failed to create user");

            }

        } catch {

            setMsg("Server error");

        }

    };



    return (

        <div style={styles.page}>

            <div style={styles.card}>

                <h2>Create User</h2>

                <form onSubmit={handleSubmit} style={styles.form}>

                    <div style={styles.field}>
                        <label>Full Name</label>
                        <input
                            value={fullName}
                            onChange={(e) => setFullName(e.target.value)}
                            required
                        />
                    </div>


                    <div style={styles.field}>
                        <label>Email</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>


                    <div style={styles.field}>
                        <label>Password</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>


                    <div style={styles.field}>
                        <label>Role</label>

                        <select
                            value={role}
                            onChange={(e) => setRole(e.target.value)}
                            required
                        >

                            <option value="">Select Role</option>

                            {roles.map(r => (
                                <option key={r.id} value={r.name}>
                                    {r.name}
                                </option>
                            ))}

                        </select>

                    </div>


                    <button style={styles.button}>
                        Create User
                    </button>

                </form>

                {msg && <p style={{ marginTop: "15px" }}>{msg}</p>}

            </div>

        </div>

    );

}

const styles = {

    page: {
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#f4f6f9"
    },

    card: {
        width: "400px",
        background: "#fff",
        padding: "30px",
        borderRadius: "10px",
        boxShadow: "0 10px 25px rgba(0,0,0,0.1)"
    },

    form: {
        display: "flex",
        flexDirection: "column",
        gap: "15px"
    },

    field: {
        display: "flex",
        flexDirection: "column",
        gap: "5px"
    },

    button: {
        marginTop: "10px",
        padding: "10px",
        border: "none",
        background: "#4f46e5",
        color: "white",
        borderRadius: "6px",
        cursor: "pointer"
    }

};